<template lang="pug">
.price-calculation-wrapper
  .card
    .top
      .left
        .card-headline Übernachtungen
      b-table(:data="priceItems")
        b-table-column(field="name" label="Name" v-slot="props")
          |{{ props.row.name }}
          br
          .disclaimer(v-if="['rentObjectPrices', 'promotions', 'discount'].includes(props.row.referenceColumnName) && props.row.totalPrice !== 0" type="is-warning" size="is-small") Provision
          .disclaimer(v-if="props.row.interval === 'daily'" type="is-light" size="is-small") Preis pro Tag
          .disclaimer(v-if="props.row.multiplier === 'person'" type="is-light" size="is-small") Preis pro Person
          .disclaimer(v-if="props.row.count === 0" type="is-light" size="is-small") ⚠ Kein Eintrag im Mietvertrag
        b-table-column(field="count" label="Anzahl" width="100" v-slot="props")
          b-field
            b {{props.row.count}}

        b-table-column(field="price" label="Preis" width="150" v-slot="props")
          b-field
            b-input(:value="props.row.price/100" @input="$set(props.row, 'price', sanitizeNumber($event) * 100); updateCalculation()" icon-right="currency-eur")

        b-table-column(field="total" label="Total" width="150" v-slot="props" numeric)
          b-field
            | {{props.row.totalPrice / 100 | toCurrency}}
      
      .button-wrapper(v-if="hasDiscount === false")
        b-button(type="is-text" icon-left="plus" @click="addDiscount()") Nachlass hinzufügen
        .spacer.md
        b-button(type="is-text" icon-left="plus" @click="addExtra()") Aufpreis hinzufügen
      .button-wrapper(v-else)
        b-button(type="is-text" icon-left="cancel" @click="removeDiscountExtra()") Nachlass/Aufpreis entfernen

      .spacer.md

      .left
        .card-headline Extras
          //- pre {{bookingItems.bookingExtraItems}}
      b-table(:data="bookingExtraItems")
        b-table-column(field="name" label="Name" v-slot="props")
          |{{ props.row.name }}
          br
          .disclaimer(v-if="props.row.referenceColumnName === 'rentObjectPrices'" type="is-warning" size="is-small") Provision
          .disclaimer(v-if="props.row.interval === 'daily'" type="is-light" size="is-small") Preis pro Tag
          .disclaimer(v-if="props.row.multiplier === 'person'" type="is-light" size="is-small") Preis pro Person
          .disclaimer(v-if="props.row.count === 0" type="is-light" size="is-small") ⚠ Kein Eintrag im Mietvertrag

        b-table-column(field="count" label="Anzahl" width="100" v-slot="props")
          b-field
            b-input(:value="props.row.count" @input="$set(props.row, 'count', sanitizeNumber($event)); updateCalculation('skipPrices')")

        b-table-column(field="price" label="Preis" width="150" v-slot="props")
          b-field
            b-input(:value="(props.row.price/100).toFixed(2)" @input="$set(props.row, 'price', sanitizeNumber($event) * 100); updateCalculation('skipPrices')" icon-right="currency-eur")

        b-table-column(field="total" label="Total" width="150" v-slot="props" numeric)
          b-field
            | {{props.row.totalPrice / 100 | toCurrency}}


      .total-sum-wrapper 
        .button-wrapper
          b-button(type="is-text" icon-left="plus" @click="toggleBookingExtraModal()") Buchungsextra hinzufügen
      
        .total-sum
          .total-name Gesamtsumme
          .total {{bookingItems.total / 100 |  toCurrency}}

      b-modal(v-model='showBookingExtraModal' has-modal-card trap-focus aria-role='dialog' aria-modal)
        template(#default='props')
          BookingSelectExtraModal(:freeBookingExtras="unusedBookingExtras"
                                  @close='props.close'
                                  @toggle="toggleBookingExtraModal()"
                                  @selectExtra="(id)=>addNewBookingExtra(id)")

      b-field(label="Provisionswert" v-if="showCommissionSelection")
        b-select(v-model="commissionId" @input="updateCalculation()")
          option(v-for="commission in commissions" :value="commission.id") {{commission.name}} {{commission.commissionPercentage}}%
      .button-wrapper(v-if="contract && bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED'")
        b-tag Provision inkl. MwSt. {{ (contract.totalCommission + contract.totalCommissionTax) / 100 | toCurrency }}
        b-tag Eigentümeranteil {{ (contract.totalSettlement) / 100 | toCurrency }}
      //.button-wrapper(v-else-if="cancelInvoice && bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL'")
        b-tag TO DO (Eigentümerabrechnung muss hierfür geklärt werden)
        //- b-tag Provision inkl. MwSt. {{ (cancelInvoice.totalCommission + cancelInvoice.totalCommissionTax) / 100 | toCurrency }}
        //- b-tag Eigentümeranteil {{ (cancelInvoice.totalSettlement) / 100 | toCurrency }}
</template>

<script>
import BookingSelectExtraModal from '@/components/molecules/BookingSelectExtraModal'

export default {
  components: {
    BookingSelectExtraModal
  },
  props: {
    bookingId: {
      type: [Number, String],
      default: 0
    },
    contract: {
      type: Object,
      default: null
    },
    rentObjectId: {
      type: Number,
      default: null
    },
    commissions: {
      type: Array,
      default() {
        return []
      }
    },
    existingCommissionId: {
      type: Number,
      default: null
    },
    startDate: {
      type: Object,
      default: null
    },
    endDate: {
      type: Object,
      default: null
    },
    persons: {
      type: Number,
      default: 1
    },
    bookingExtras: {
      type: Array,
      default() {
        return []
      }
    },
    existingBookingItems: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    showCommissionSelection: {
      type: Boolean,
      default: true
    },
    bookingStatus: {
      type: Object,
      default() {
        return {
          uuid: "STATUS_BOOKING_INTERNET"
        }
      }
    }
  },
  data() {
    return {
      commissionId: null,
      bookingItems: {},
      showBookingExtraModal: false
    }
  },
  mounted() {
    this.mountData();
  },
  watch: {
    endDate() {
      this.throttleUpdate();
    },
    persons() {
      this.updateCalculation('newPrices');
    },
  },
  computed: {
    priceItems() {
      return this.bookingItems.priceItems;
    },
    bookingExtraItems() {
      return this.bookingItems.bookingExtraItems;
    },
    hasDiscount() {
      if (!this.bookingItems || !this.bookingItems.priceItems) return false;
      const discount = this.bookingItems.priceItems.find(b => b.referenceColumnName === 'discount');
      return !!discount;
    },
    unusedBookingExtras() {
      const unusedBookingExtras = [];
      for (let i = 0; i < this.bookingExtras.length; i += 1) {
        let unused = true;
        for (let x = 0; x < this.bookingItems.bookingExtraItems.length; x += 1) {
          if (this.bookingExtras[i].id === this.bookingItems.bookingExtraItems[x].referenceId) {
            unused = false;
            break;
          }
        }
        if (unused) {
          unusedBookingExtras.push(this.bookingExtras[i]);
        }
      }
      return unusedBookingExtras;
    }
  },
  methods: {
    mountData() {
      this.commissionId = this.existingCommissionId;
    
      // When bookingItems are available we know that the booking already exisits
      this.bookingItems.bookingExtraItems = this.existingBookingItems.filter(b => b.referenceColumnName === 'rentObjectBookingExtras');
      this.bookingItems.priceItems = this.existingBookingItems.filter(b => ['rentObjectPrices', 'promotions', 'discount'].includes(b.referenceColumnName));

      let total = 0;
      for (let i = 0; i < this.existingBookingItems.length; i += 1) {
        total += this.existingBookingItems[i].totalPrice;
      }
      this.bookingItems.total = total;

      // We get the data here for the first time
      if (this.bookingId) {
        this.updateCalculation('initial');
      } else {
        this.updateCalculation();
      }
    },
    throttleUpdate () {               // We return a throttled function
      if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        this.updateCalculation();
      }, 300);
    },
    toggleBookingExtraModal() {
      this.showBookingExtraModal = !this.showBookingExtraModal;
    },
    sanitizeNumber(nbr) {
      // So that nobody can type in weired data
      if (!parseInt(nbr)) return 0
      if (nbr.length <= 0) return 0
      return parseFloat(nbr)
    },
    addNewBookingExtra(id) {
      this.showBookingExtraModal = false;
      const bookingExtraData = this.unusedBookingExtras.find(r=>r.id === id);
      if (!bookingExtraData) return;

      const newBookingExtra = {
        referenceId: bookingExtraData.id,
        referenceColumnName: 'rentObjectBookingExtras',
        name: bookingExtraData.name,
        price: bookingExtraData.price,
        count: 0,
        totalPrice: 0,
        comment: bookingExtraData.description,
        interval: bookingExtraData.interval,
        includeCommission: bookingExtraData.includeCommission,
        includeCancelInvoice: bookingExtraData.includeCancelInvoice,
        isMandatory: false,
        isOptional: true
      }
      this.bookingItems.bookingExtraItems.push(newBookingExtra);
    },
    addDiscount() {
      const newPriceItem = {
        referenceId: -1,
        referenceColumnName: 'discount',
        name: 'Nachlass gem. Individualvereinbarung',
        price: 0,
        count: 1,
        totalPrice: 0,
        comment: 'Nachlass gem. Individualvereinbarung',
        interval: 'once',
        includeCommission: true,
        includeCancelInvoice: true,
        isMandatory: true,
        isOptional: false
      }
      this.bookingItems.priceItems.push(newPriceItem);
    },
    addExtra() {
      const newPriceItem = {
        referenceId: -1,
        referenceColumnName: 'discount',
        name: 'Aufpreis gem. Individualvereinbarung',
        price: 0,
        count: 1,
        totalPrice: 0,
        comment: 'Aufpreis gem. Individualvereinbarung',
        interval: 'once',
        includeCommission: true,
        includeCancelInvoice: true,
        isMandatory: true,
        isOptional: false
      }
      this.bookingItems.priceItems.push(newPriceItem);
    },
    removeDiscountExtra() {
      for (let i = 0; i < this.bookingItems.priceItems.length; i += 1) {
        if (this.bookingItems.priceItems[i].referenceId === -1) this.bookingItems.priceItems.splice(i, 1);
      }
      this.updateCalculation("skipPrices");
    },
    updateCalculation (mode, callback) {
      this.$nextTick(async function () {
        // DOM needs to be updated
        // so that changes to the optional booking extra count
        // are as well already updated and then used for the next calculcation
        if (!this.startDate || !this.endDate) return;

        // If any of the counts or prices equals to null or undefined we don't update the price
        this.bookingItems.priceItems.forEach(b => {
          if (!b.price || !b.count) return;
        });
        this.bookingItems.bookingExtraItems.forEach(b => {
          if (b.price === null || b.price === undefined || b.count === null || b.count === undefined) return;
        });

        const items = await this.$store.dispatch("rentObjectBookings/calculatePrice", {
          bookingId: this.bookingId,
          rentObjectId: this.rentObjectId,
          startDate: this.startDate,
          endDate: this.endDate,
          mode: mode,
          priceItems: ['newPrices', 'newExtras', 'initial'].includes(mode) ? undefined : this.bookingItems.priceItems,
          bookingExtraItems: ['newExtras', 'initial'].includes(mode) || !this.bookingItems.bookingExtraItems || this.bookingItems.bookingExtraItems.length === 0 ? undefined : this.bookingItems.bookingExtraItems,
          persons: this.persons
        });

        // When first loaded we zero out all numbers not included in the contract
        if (mode === 'initial') {
          this.bookingItems.bookingAllowed = items.bookingAllowed;
          this.bookingItems.startDate = items.startDate;
          this.bookingItems.endDate = items.endDate;
          items.bookingExtraItems.forEach(b => {
            const oldItem = this.bookingItems.bookingExtraItems.find(bOld => bOld.referenceId === b.referenceId);
            if (!oldItem) {
              b.count = 0;
              b.totalPrice = 0;
              this.bookingItems.bookingExtraItems.push(b);
            }
          });
          items.total = 0;
        }

        // HERE WE SET THE NEW ITEMS FROM THE SERVER
        if (mode === 'initial') {
          this.$set(this, "bookingItems", {...this.bookingItems});
        } else {
          this.bookingItems = items;
        }

        // If STATUS_BOOKING_PERSONAL then we make all numbers zero
        if (mode === 'newExtras' && this.bookingStatus.uuid === 'STATUS_BOOKING_PERSONAL') {
          this.bookingItems.priceItems.forEach(b => {
            b.price = 0;
            b.totalPrice = 0;
          });
          this.bookingItems.bookingExtraItems.forEach(b => {
            b.count = 0;
            b.price = 0;
            b.totalPrice = 0;
          });
          this.bookingItems.total = 0;
        }

        this.$emit("update", {...this.bookingItems, commissionId: this.commissionId});
        if (callback) {
          callback;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.price-calculation-wrapper {
  min-width: 512px;
}
.total-sum-wrapper {
  text-align: right;
  display: flex;
  justify-content: space-between;
  .total {
    font-weight: bold;
    border-bottom: double 3px;
  }
}
.disclaimer {
  font-size: 11px;
  color: $gray;
}
</style>